import { PureComponent } from "react";

import yup from "utilities/form/yup";

import { Currency } from "commonComponents/financial/Currency/Currency";
import { CurrencyDisplay } from "commonComponents/financial/CurrencyDisplay/CurrencyDisplay";
import { type INumberResponse } from "commonComponents/utilities/Grid/common/columnImplementations/columnCurrency";
import { type IGridCellRenderProps } from "commonComponents/utilities/Grid/Grid.types";
import {
    GridColumnType,
    type IClientGridColumn,
    type IGridFilterCellRenderProps,
} from "commonComponents/utilities/Grid/GridContainer.types";

const noop = () => {};

class CurrencyLimitFilterCell extends PureComponent<
    IGridFilterCellRenderProps<INumberResponse | undefined>
> {
    private handleChange = (field: string, value: number | undefined) => {
        const { cellValue, onChange } = this.props;
        onChange(field, {
            precision: 0,
            ...cellValue,
            value,
        });
    };
    render() {
        const { cellValue, field } = this.props;
        return (
            <Currency<undefined>
                id={field.full}
                data-testid={field.full}
                value={cellValue ? cellValue.value : undefined}
                onChange={this.handleChange}
                onBlur={noop}
                decimalScale={cellValue ? cellValue.scale : undefined}
            />
        );
    }
}

class CurrencyLimitCell extends PureComponent<IGridCellRenderProps<INumberResponse | undefined>> {
    render() {
        const { cellValue } = this.props;
        const unlimitedString = "Unlimited";

        if (cellValue) {
            return cellValue.value !== undefined && cellValue.value !== null ? (
                <CurrencyDisplay value={cellValue.value} decimalScale={cellValue.scale} />
            ) : (
                unlimitedString
            );
        }
        return unlimitedString;
    }
}

export const columnCurrencyLimit: IClientGridColumn<INumberResponse | undefined> = {
    validationSchema: yup.object<INumberResponse>({
        value: yup.number(),
        scale: yup.number(),
    }),
    columnType: GridColumnType.currencyLimit,
    FilterCell: CurrencyLimitFilterCell,
    Cell: CurrencyLimitCell,
};
